<template>
  <div id="devices_network_setup">
    <v-radio-group v-model="network_role" style="margin-top: 5px">
      <div style="display: flex; justify-content: space-around">
        <v-radio
            :label="$i18n.t('pages.system.devices_network_settings.master')"
            value="master"
            style="margin-bottom: 0"
            color="#207EA9"
        />
        <v-radio
            :label="$i18n.t('pages.system.devices_network_settings.slave')"
            value="slave"
            style="margin-bottom: 0"
            color="#207EA9"
        />
        <v-radio
            :label="$i18n.t('pages.system.devices_network_settings.standalone')"
            value="standalone"
            style="margin-bottom: 0"
            color="#207EA9"
        />
      </div>
    </v-radio-group>
    <v-subheader class="subheader">{{ $i18n.t('pages.system.devices_network_settings.device_name') }}</v-subheader>
    <v-text-field
        v-model="name"
        outlined
        class="rounded_8px height_56px"
        @change="set_system_params({name: name})"
    />
    <div v-if="network_role === 'slave'" style="margin-top: 10px">
      <v-subheader class="subheader">{{ $i18n.t('pages.system.devices_network_settings.master_device_address') }}</v-subheader>
      <v-text-field
          v-model="network_connection_url"
          outlined
          class="rounded_8px height_56px"
          @change="set_system_params({network_connection_url: network_connection_url})"
      />
    </div>
    <div v-if="network_role === 'master'" style="margin-top: 10px">
      <v-subheader class="subheader">{{ $i18n.t('pages.system.devices_network_settings.connected_devices_settings') }}</v-subheader>
      <div style="display: flex; justify-content: space-between;">
        <slaves-settings>
          <template v-slot:button>
            <v-btn
                class="white--text mr-1 ml-1"
                style="border-radius: 4px"
                color="#DBEAF1"
                elevation="0"
                height="42"
            >
              <span class="main_color button-font">{{ $i18n.t('pages.system.devices_network_settings.slaves_settings') }}</span>
            </v-btn>
          </template>
        </slaves-settings>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {i18n} from "@/i18n";
import SlavesSettings from "./SlavesSettings";

export default {
  name: "DevicesNetworkSetup",
  components: {SlavesSettings},
  data: function () {
    return {
    }
  },
  methods: {
    set_system_params: function (system_params_dict) {
      let data = {params: system_params_dict}
      this.$http({
        url: this.$http_hostname + '/system_settings/set_config_params',
        data: data,
        method: 'POST'
      })
      .then(() => {
        this.setSnackbar({
          text: 'PH: Изменения сохранены' + ". " +
              i18n.t('general.device_restart_required')
        })
        this.updateSystemParams(system_params_dict)
      })
      .catch(error => {
        console.log(error)
      })
    },
    ...mapActions(['setSnackbar', 'updateSystemParams']),
  },
  computed: {
    network_role: {
      get () {
        return this.systemParams.network_role
      },
      set (value) {
        this.set_system_params({network_role: value})
      }
    },
    name: {
      get () {
        return this.systemParams.name
      },
      set (value) {
        this.updateSystemParams({
          name: value
        })
      },
    },
    network_connection_url: {
      get () {
        return this.systemParams.network_connection_url
      },
      set (value) {
        this.updateSystemParams({
          network_connection_url: value
        })
      }
    },
    ...mapGetters(['systemParams'])
  }
}
</script>

<style>

</style>